/** @jsxImportSource react */
import { normJsonApi } from '@common/helpers/jsonApi';
import { useQuery } from '@react/services/api';
import { Select } from '@react/system';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types'; // Corrected import
import { useMemo } from 'react';

function getDefaultTransformOptions(communities) {
  return communities.map((item) => ({
    label: item.name,
    value: item.id,
  }));
}

const SearchAutoComplete = ({
  filters = {},
  limit = 5,
  transformOptions = getDefaultTransformOptions,
  ...props
}) => {
  const getSearch = useQuery('getSearch');

  const loadOptions = useMemo(() => {
    const debouncedLoadOptions = debounce((inputValue, callback) => {
      if (!inputValue) {
        callback([]);
        return;
      }

      getSearch({
        'filter[query]': inputValue,
        'page-size': limit,
        include: 'community',
        ...filters,
      })
        .then((response) => {
          const data = normJsonApi(response);
          if (!data) {
            callback([]);
            return;
          }
          const options = transformOptions(data);
          callback(options);
        })
        .catch((error) => {
          console.error('Error fetching search results:', error);
          callback([]);
        });
    }, 300);

    return debouncedLoadOptions;
  }, [getSearch, limit, filters, transformOptions]);

  return <Select async isSearchable loadOptions={loadOptions} {...props} />;
};

SearchAutoComplete.propTypes = {
  filters: PropTypes.object,
  limit: PropTypes.number,
  transformOptions: PropTypes.func,
};

export default SearchAutoComplete;
